import { useMemo } from 'react';
import { TransferQueueTable } from '../../components/custodian/TransferQueueTable';

/**
 * Pledge and release transactions (BRD EV-19, EV-21). Same engine as transfers;
 * only the pledgee facets and the pledged flag may change.
 */
export function PledgeQueuePage() {
  const types = useMemo(() => ['PLEDGE', 'RELEASE'], []);
  return (
    <TransferQueueTable
      title="Pledge and release transactions"
      types={types}
      intro="Pledge and release instructions from the current control party. A pledge records the pledgee on the authority record without moving ownership or custody; a release clears it. Commit issues the pledge or release receipt."
      emptyMessage="No pledge or release transactions."
    />
  );
}
